import { fork } from "@redux-saga/core/effects";

const extractRequestFunctions = functionsObj =>
  Object.values(functionsObj).map(f => fork(f));

const sagaUtils = { extractRequestFunctions };

export default sagaUtils;
